import React from 'react'
import type { Icon } from 'shared/utils'

const Google = (props: Icon) => {
    const { color = 'white', size = 24, className = 'google' } = props
    return (
        <svg fill={color} width={size} height={size} className={className}>
            <g fill="none" fillRule="evenodd">
                <path
                    d="M20.856 10.06c.078 0 .144 1.23.144 1.82 0 5.14-3.516 9.12-8.817 9.12C7.107 21 3 16.974 3 12.002 3 7.03 7.107 3 12.183 3c2.48 0 4.553.872 6.153 2.337L15.843 7.66a5.226 5.226 0 0 0-3.66-1.446c-3.135 0-5.694 2.427-5.694 5.562 0 3.136 2.559 5.449 5.694 5.449 3.634 0 5-2.934 5.208-4.344H11.64v-2.82h9.216z"
                    fill={color}
                />
                <path d="M0 0h24v24H0z" />
            </g>
        </svg>
    )
}

export { Google }
